import React from 'react';
import { Container } from 'react-bootstrap';
import { usePwaUpdate } from '../../hooks/usePwaUpdate';
import PwaUpdateToast from '../common/PwaUpdateToast';
import Navigation from './Navigation';

const Layout = (props) => {
    const pwaUpdate = usePwaUpdate();

    return (
        <div>
            <Navigation />
            <Container className='pt-4'>
                {props.children}
            </Container>

            <PwaUpdateToast show={pwaUpdate.show} onDismiss={pwaUpdate.handleDismiss} onReload={pwaUpdate.handleReload} />
        </div>
    );
}

export default Layout;